import React from "react";
import Table from "../../../components/Table/Table";
import { Button, FormControlLabel, Switch } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { ToastContainer } from "react-toastify";
import { Spinner } from "../../../components/Spinner/Spinner";
import { Pagination } from "../../../components/pagination/Pagination";
import SearchAndStatusFilter from "../../../components/SearchAndStatusFilter";
import Modal from "../../../components/Modal";
import useVendor from "./hooks/useVendor";
import TextFields from "../../../components/TextField";
import useCategory from "./hooks/useCategory";
import useReduxStore from "../../../hooks/useReduxStore";

const Category = () => {
  const { selector: user } = useReduxStore("auth");
  const { data, methods } = useCategory();
  const {
    totalCount,
    controller,
    formError,
    spinner,
    vendorModal,
    isEditMode,
    openModal,
    categoryList,
    formDataCategory,
    filter,
  } = data;
  const {
    handleChange,
    handleCloseModal,
    handleOpenModal,
    handlePagination,
    categoryAdd,
    categoryDelete,
    categoryUpdate,
    handleToggleChange,
    handleSearchChange,
    handleStatusChange,
    handleApplyFilter,
    handleResetFilter,
  } = methods;

  const TableHead = [
    { label: "#", id: "" },
    { label: "Name", id: "" },
    { label: "Status", id: "" },
    { label: "Action", id: "" },
  ];
 
  return (
    <>
      <ToastContainer />
      {/* {isLoading && <Spinner />} */}
      <div className="container-fluid py-3">
        <div className="row">
          <div className="d-flex justify-content-between">
            <div className="d-flex">
              <SearchAndStatusFilter
                search={filter.search}
                statusType={filter.isDeleted}
                onSearchChange={handleSearchChange}
                setStatusType={handleStatusChange}
                applayFilter={handleApplyFilter}
                reset={handleResetFilter}
              />
            </div>
            <div className="d-flex align-items-end">
                {user?.userInfo?.permission?.inventory?.add?.value &&
              <Button
                onClick={() => handleOpenModal("add")}
                className="dropDownButtons11 ms-4"
                startIcon={<AddIcon />}
              >
                Add New
              </Button>
                 }
            </div>
          </div>
        </div>
        <div className="row py-3">
          <div className="col-lg-12 ticet">
            <div className="bg shadow raduus pt-2">
              <div className="">
                <div className="mt-2">
                  <table className="table">
                    <Table TableHeadData={TableHead} />
                    <tbody>
                      {categoryList?.map((item, index) => {
                        return (
                          <tr
                            key={item._id}
                            // className="text-start rounded-row "
                            className={item.isDeleted ? 'table-active text-start rounded-row tablebess border-top-0 border-start-0 border-end-0 border-light' : `text-start rounded-row tablebess `}

                            style={{
                              borderRadius: "50px",
                              backgroundColor: "#fff",
                            }}
                          >
                            <td className="table-link">
                              {controller.rowsPerPage * (controller.page - 1) +
                                index +
                                1}{" "}
                            </td>
                            <td className="">{item?.name}</td>
                            <td className="">
                              <FormControlLabel
                                control={
                                  <Switch disabled={item?.isDeleted }
                                    checked={item?.isActive}
                                    onChange={() =>
                                      handleToggleChange(
                                        item._id,
                                        item.isActive
                                      )
                                    }
                                  />
                                }
                              />
                            </td>
                            <td>
                              <div className="dropdown p-0 align-items-center justify-content-center">
                                <i
                                  className="fas fa-ellipsis-v pointer p-2"
                                  id="dropdownMenuLink"
                                  data-bs-toggle={
                                user?.userInfo?.permission?.inventory?.edit?.value ? "dropdown" : ""
                                }
                                  aria-expanded="false"
                                  style={{
                                cursor: user?.userInfo?.permission?.inventory
                                  ?.edit?.value
                                  ? "pointer"
                                  : "not-allowed",
                                  //  pointerEvents: item.isDeleted ? "none" : "auto",
                              }}
                                />
                                <ul
                                  className="dropdown-menu"
                                  aria-labelledby="dropdownMenuLink"
                                >
                                  {item.isDeleted ? "" :  <li
                                    onClick={() =>
                                      handleOpenModal("edit", item)
                                    }
                                    style={{ cursor: "pointer" }}
                                    className="dropdown-item"
                                  >
                                    Edit
                                  </li>  }

                                  <li
                                    className="dropdown-item"
                                    style={{ cursor: "pointer" }}
                                  
                                     onClick={() => categoryDelete(item._id, item.isDeleted)}
                                  >
                                  {item.isDeleted ? 'Recover' : 'Delete'}
                                  </li>
                                </ul>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  {!categoryList?.length && (
                    <div className="text-center">No record found</div>
                  )}
                  <Pagination
                    count={totalCount}
                    controller={controller}
                    setController={handlePagination}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        size="md"
        show={openModal.addCategory || openModal.editCategory}
        onHide={handleCloseModal}
        headerContent={
          <h5>{openModal.editCategory ? "Edit Category" : "Add Category"}</h5>
        }
        bodyContent={
          <div className="">
            <div className="row">
              <div className="pt-2">
                <TextFields
                  Lable="Category"
                  Name="name"
                  variant="outlined"
                  ClassName="form-field-design"
                  HandleInputChange={handleChange}
                  Value={formDataCategory.name}
                  Require={true}
                  width={100}
                />
              </div>
              {formError.name && (
                <small className="text-danger">{formError.name}</small>
              )}
            </div>

            <div className="d-flex justify-content-end mt-4">
              <Button variant="contained" onClick={handleCloseModal}>
                cancel
              </Button>
              {openModal.editCategory ? (
                <Button
                  onClick={categoryUpdate}
                  variant="outlined"
                  className="ms-2"
                  data-bs-dismiss="modal"
                >
                  Update
                </Button>
              ) : (
                <Button
                  onClick={categoryAdd}
                  variant="outlined"
                  className="ms-2"
                  data-bs-dismiss="modal"
                >
                  Add
                </Button>
              )}
            </div>
          </div>
        }
      />
    </>
  );
};

export default Category;
